import React, { useEffect, useState } from 'react';
const STORAGE_KEY = 'art-ready-launch-offer-deadline';
const DAY_IN_MS = 24 * 60 * 60 * 1000;
interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    hours: 24,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    function getDeadline() {
      const storedDeadline = window.localStorage.getItem(STORAGE_KEY);
      const parsedDeadline = storedDeadline ? Number(storedDeadline) : 0;
      const now = Date.now();
      if (!Number.isFinite(parsedDeadline) || parsedDeadline <= now) {
        const newDeadline = now + DAY_IN_MS;
        window.localStorage.setItem(STORAGE_KEY, String(newDeadline));
        return newDeadline;
      }
      return parsedDeadline;
    }
    let deadline = getDeadline();
    function updateTimer() {
      const now = Date.now();
      if (deadline <= now) {
        deadline = now + DAY_IN_MS;
        window.localStorage.setItem(STORAGE_KEY, String(deadline));
      }
      const remainingSeconds = Math.max(0, Math.ceil((deadline - now) / 1000));
      setTimeLeft({
        hours: Math.floor(remainingSeconds / 3600),
        minutes: Math.floor(remainingSeconds % 3600 / 60),
        seconds: remainingSeconds % 60
      });
    }
    updateTimer();
    const intervalId = window.setInterval(updateTimer, 1000);
    return () => window.clearInterval(intervalId);
  }, []);
  return <aside className="sticky top-0 z-50 flex h-8 w-full items-center justify-center bg-brand-red px-2 text-white shadow-sm" data-id="element-235">
      <div className="flex items-center gap-2 sm:gap-3" data-id="element-236">
        <p className="whitespace-nowrap text-[9px] font-extrabold tracking-wide sm:text-[10px]" data-id="element-237">
          ⏳ LAUNCH OFFER ENDS IN:
        </p>
        <div className="flex items-center gap-1 font-mono" aria-label={`${timeLeft.hours} hours, ${timeLeft.minutes} minutes, ${timeLeft.seconds} seconds remaining`} data-id="element-238">
          <TimerUnit value={timeLeft.hours} label="HRS" data-id="element-239" />
          <span className="text-xs font-bold leading-none" data-id="element-240">:</span>
          <TimerUnit value={timeLeft.minutes} label="MIN" data-id="element-241" />
          <span className="text-xs font-bold leading-none" data-id="element-242">:</span>
          <TimerUnit value={timeLeft.seconds} label="SEC" data-id="element-243" />
        </div>
      </div>
    </aside>;
}
function TimerUnit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="whitespace-nowrap text-[11px] font-extrabold leading-none sm:text-xs" data-id="element-244">
      {String(value).padStart(2, '0')}
      <span className="ml-0.5 text-[8px] font-bold text-white/75" data-id="element-245">{label}</span>
    </span>;
}